'use client';

interface ToggleFieldProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
}

export default function ToggleField({
  id,
  checked,
  onChange,
  label,
  description,
  disabled = false,
}: ToggleFieldProps) {
  return (
    <div data-component-id="src/app/provider-profile-form/components/ToggleField.tsx:21:4" data-component-path="src/app/provider-profile-form/components/ToggleField.tsx" data-component-line="21" data-component-end-line="67" data-component-file="ToggleField.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20gap-3%20py-2.5%20px-3%20rounded-lg%20border%20border-input%20bg-white%20hover%3Aborder-primary%2F40%20transition-colors%20duration-150%22%7D" className="flex items-start gap-3 py-2.5 px-3 rounded-lg border border-input bg-white hover:border-primary/40 transition-colors duration-150">
      <button data-component-id="src/app/provider-profile-form/components/ToggleField.tsx:22:6" data-component-path="src/app/provider-profile-form/components/ToggleField.tsx" data-component-line="22" data-component-end-line="45" data-component-file="ToggleField.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22id%22%3A%22%5Bvar%3Aid%5D%22%7D"
        type="button"
        id={id}
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`
          relative flex-shrink-0 mt-0.5 w-10 h-5.5 rounded-full transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-primary/30 focus:ring-offset-1
          disabled:opacity-50 disabled:cursor-not-allowed
          ${checked ? 'bg-primary' : 'bg-muted-foreground/30'}
        `}
        style={{ height: '22px', minWidth: '40px' }}
      >
        <span data-component-id="src/app/provider-profile-form/components/ToggleField.tsx:38:8" data-component-path="src/app/provider-profile-form/components/ToggleField.tsx" data-component-line="38" data-component-end-line="44" data-component-file="ToggleField.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
          className={`
            absolute top-0.5 left-0.5 w-[18px] h-[18px] bg-white rounded-full shadow-sm
            transition-transform duration-200
            ${checked ? 'translate-x-[18px]' : 'translate-x-0'}
          `}
        />
      </button>
      <div data-component-id="src/app/provider-profile-form/components/ToggleField.tsx:46:6" data-component-path="src/app/provider-profile-form/components/ToggleField.tsx" data-component-line="46" data-component-end-line="56" data-component-file="ToggleField.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%20min-w-0%22%7D" className="flex-1 min-w-0">
        <label data-component-id="src/app/provider-profile-form/components/ToggleField.tsx:47:8" data-component-path="src/app/provider-profile-form/components/ToggleField.tsx" data-component-line="47" data-component-end-line="52" data-component-file="ToggleField.tsx" data-component-name="label" data-component-content="%7B%22elementName%22%3A%22label%22%2C%22className%22%3A%22text-sm%20font-semibold%20text-foreground%20cursor-pointer%20leading-tight%20block%22%7D"
          htmlFor={id}
          className="text-sm font-semibold text-foreground cursor-pointer leading-tight block"
        >
          {label}
        </label>
        {description && (
          <p data-component-id="src/app/provider-profile-form/components/ToggleField.tsx:54:10" data-component-path="src/app/provider-profile-form/components/ToggleField.tsx" data-component-line="54" data-component-end-line="54" data-component-file="ToggleField.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20text-muted-foreground%20mt-0.5%20leading-relaxed%22%7D" className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{description}</p>
        )}
      </div>
      <span data-component-id="src/app/provider-profile-form/components/ToggleField.tsx:57:6" data-component-path="src/app/provider-profile-form/components/ToggleField.tsx" data-component-line="57" data-component-end-line="66" data-component-file="ToggleField.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
        className={`
          flex-shrink-0 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5
          ${checked
            ? 'bg-accent/15 text-accent' :'bg-muted text-muted-foreground'
          }
        `}
      >
        {checked ? 'Yes' : 'No'}
      </span>
    </div>
  );
}